module.exports = __webpack_public_path__ + "static/og_image-0b2908285df342467d3abdef78f90890.jpg";